import React, { Component } from "react";

import {Button ,ButtonGroup,Glyphicon,Form, FormGroup, ControlLabel ,FormControl,ToggleButtonGroup ,ToggleButton,Well, Label} from "react-bootstrap";
import "./Logic.css"

/*


      Create Logical conditions from input data


      I would like this interface to cope with the more complex arrangment of logic

      //Possible in-puts are
      //InputXvalue
      //outputXstate
      //on True do this
      //on False do this


      Enable/Diable logic
      Description auto generation



      Logic can be nested in the heating sheduler that was used for clowne
      two types of logic were manually created
      one was if any of the output zones were turned on, automaticly turn on the pump
      the other was for cotrolling if the heating was on or off

      ```JSON
      {
            "or":[{"opperator":"==","data":{"v1":{"var":"temperature_1_enabled"},"v2":{"value":2}}},
                {"and":[
                    {"opperator":"==","data":{"v1":{"var":"temperature_1_enabled"},"v2":{"value":1}}},
                    {"or":[
                        {"opperator":"<=","data":{"v1":{"var":"temperature_1"},"v2":{"var":"Heating_Schedule_1"}}},
                        {"and":[
                            {"opperator":"==","data":{"v1":{"var":"temperature_1_boost"},"v2":{"value":1}}},
                            {"opperator":"<=","data":{"v1":{"var":"temperature_1"},"v2":{"var":"temperature_1_boost_temp"}}}
                        ]}]
                    }
            ]}]}
      ```

*/



function obIndex(obj, is, value) {
    if (typeof is == 'string')
        return obIndex(obj,is.split('.'), value);
    else if (is.length==1 && value!==undefined)
        return obj[is[0]] = value;
    else if (is.length==0)
        return obj;
    else
        return obIndex(obj[is[0]],is.slice(1), value);
}



function pad(num, size) {
    var s = "000000000" + num;
    return s.substr(s.length-size);
}


function highlight(v1,v2){
  if(v1===v2){
      return "active"
  }
}

function ArrayInculdes(item,array){
  if(array.includes(item)){
    return "active"
  }
  return

}


function MacroSelect(props){
  let macrolist={"enum":[],"enumNames":[]}
  for (var key in props.macros){
    macrolist.enum.push(key)
    macrolist.enumNames.push(props.macros[key].name)
  }
  return (<select key={"LogicCreateMacroChoice-"+props.id} value={props.current} onChange={(e)=>props.callback(e,props.id)}>
    <option value="">None</option>
      {macrolist.enum.map((d,i) =><option value={d} key={d}>{macrolist.enumNames[i]}</option>)}
    </select>)
}






export default class ConditionCreate extends Component {
    constructor(props) {
      super(props);
      this.state = {
        data:props.data,
        showEdit:false,
        editIndex:0,
        newAction:false,
        addNew:false,
        nameEdit:false,
        redraw:true,
        tree:[],
        conditionEdit:false,
        conditionTree:{"Option A":{"A1":{"A1 A":{},"A1 B":{},"A1 C":{}},"A2":{"A2 A":{},"A2 B":{},"A2 C":{}},"A3":{"A3 A":{},"A3 B":{},"A3 C":{}}},"Option B":{"B1":{"B1 A":{},"B1 B":{},"B1 C":{}},"B2":{"B2 A":{},"B2 B":{},"B2 C":{}},"B3":{"B3 A":{},"B3 B":{},"B3 C":{}}}},
        currentTree:{"Option A":{"A1":{"A1 A":{},"A1 B":{},"A1 C":{}},"A2":{"A2 A":{},"A2 B":{},"A2 C":{}},"A3":{"A3 A":{},"A3 B":{},"A3 C":{}}},"Option B":{"B1":{"B1 A":{},"B1 B":{},"B1 C":{}},"B2":{"B2 A":{},"B2 B":{},"B2 C":{}},"B3":{"B3 A":{},"B3 B":{},"B3 C":{}}}},
        macroList:{"enum": [], "enumNames": []},
        varlist:{"enum": [], "enumNames": []},
        outList:{"enum": [], "enumNames": []}
      };
    }

    componentDidUpdate(prevProps){

    }


    componentWillMount(){
      console.log(this.props.data)
      if(this.props.new==true)
        this.buildConditionTree()


        if(this.props.lastedit==this.props.uid){
          //open in editmode

          this.setState({conditionEdit:!this.state.conditionEdit})
      }
    }


    buildConditionTree(){
      var t={
                "Inputs":{},
                "Outputs":{},
                "Vars":{},
                "Time":{"Between time":JSON.stringify({"opperator":"between_time","data":{"start":{"hours":9,"mins":0},"end":{"hours":17,"mins":10}} }),"Weekdays":JSON.stringify({"opperator":"weekday","data":{"days":["mon","tue","wed"]} })   },
                "OR":"or",
                "AND":"and"
            }
      var inputs=this.props.inputs
      var outputs=this.props.outputs
      var vars=this.props.vars
      //Populate the list with input options

      for(var i=0;i<inputs.length;i++){
        var inactive  =   {"opperator":"==","data":{"v1":{"var":"input"+inputs[i]["id"]+"filtered"},"v2":{"value":0}}}
        var active    =   {"opperator":"==","data":{"v1":{"var":"input"+inputs[i]["id"]+"filtered"},"v2":{"value":1}}}
        var temp_plate=   {"opperator":">=","data":{"v1":{"var":"input"+inputs[i]["id"]+"filtered"},"v2":{"value":20}}}
        var temp_var=   {"opperator":">=","data":{"v1":{"var":"input"+inputs[i]["id"]+"filtered"},"v2":{"var":"varname"}}}
        var renderInput=true
        if("disabled" in inputs[i]){
          if(inputs[i].disabled==true)
              renderInput=false
        }

        if(renderInput==true){
          if("type" in inputs[i]){
            if(inputs[i].type==512 ||  inputs[i].name_active ==inputs[i].name_inactive){
              t["Inputs"][inputs[i].name]={"Value":JSON.stringify(temp_plate),"Varaible":JSON.stringify(temp_var)}
            }
            else{
              t["Inputs"][inputs[i].name]={[inputs[i].name_active]:JSON.stringify(active),[inputs[i].name_inactive]:JSON.stringify(inactive)}
            }
          }
          else{
            t["Inputs"][inputs[i].name]={[inputs[i].name_active]:JSON.stringify(active),[inputs[i].name_inactive]:JSON.stringify(inactive)}
          }
        }
      }

      for(var i=0;i<outputs.length;i++){
        var inactive  =   {"opperator":"==","data":{"v1":{"var":"O"+outputs[i]["id"]+"state"},"v2":{"value":0}}}
        var active    =   {"opperator":"==","data":{"v1":{"var":"O"+outputs[i]["id"]+"state"},"v2":{"value":1}}}

        renderInput=true
        var devtypes=["RELAY PACK","DECT SOCKET","RF_SOCKET"]
        if(renderInput==true){
          if("ctrlType" in outputs[i]){
            if(devtypes.includes(outputs[i].ctrlType)){
              t["Outputs"][outputs[i].name+" ("+outputs[i].id+")"]={["On"]:JSON.stringify(active),["Off"]:JSON.stringify(inactive)}
            }
        }
      }
    }

    for(var i=0;i<vars.length;i++){
      //var inactive  =   {"opperator":"==","data":{"v1":{"var":vars[i]["id"]},"v2":{"value":0}}}
      var var_temp    =   {"opperator":">=","data":{"v1":{"var":vars[i]["id"]},"v2":{"value":1}}}

      renderInput=true
      var vartypes=["number"]

      if(renderInput==true){
        if("type" in vars[i]){
          if(vartypes.includes(vars[i].type)){
            t["Vars"][vars[i].name+" ("+vars[i].id+")"]={["Value"]:JSON.stringify(var_temp)}
          }
      }
    }
  }



    if (Object.keys(t.Vars).length==0){
      delete t.Vars
    }

    if (Object.keys(t.Outputs).length==0){
      delete t.Outputs
    }



      this.setState({conditionTree:t})
      this.setState({currentTree:t})

    }

    expandTree(option,test=""){
      console.log("Tree expand")
      console.log(option)
      var tree=this.state.tree
      var contree=this.state.conditionTree

      if(typeof(option)==="number"){
        tree=tree.splice(0,option)
        this.setState({"tree":tree})
      }
      if(tree.length>0){
        for (var i=0;i<tree.length;i++){
          contree=contree[tree[i]]
        }
      }

      if(typeof(option)!=="number"){
        tree.push(option)

        this.setState({"tree":tree})
        if( option in contree){
          console.log("OPTION LEN "+typeof(contree[option]))
          console.log(contree[option])
          if(typeof(contree[option])==="string"){
            try{
              var con=JSON.parse(contree[option])
            }catch(err){
              var con=contree[option]
            }
            this.appendCondtion(con)
            this.setState({"newCondition":false})
            return;
          }
          this.setState({"currentTree":contree[option]})
        }
      }
      else{
        this.setState({"currentTree":contree})
      }




    }


    deleteCon=()=>{
        this.setState({conditionEdit:false})
        console.log("delete condition "+this.props.index)
        this.props.callback("delete",this.props.index)
    }


    appendCondtion(con){
        console.log("+ + + + + ADD CONDITION + + + + +")
        console.log(con)
        //Where does it get inserted

        //Append edit

        if(con.opperator=="between_time" || con.opperator==">="||con.opperator=="weekday"){
            this.props.callback("appendedit",con)
        }
        else{
              this.props.callback("append",con)
        }
    }



select=(macroAssignment)=>{
    console.log(" show Action select and assign it to the macros "+macroAssignment+" action")


}

cancelCon(){
  this.props.callback("cancel",{})

}



alterCondition(e,i){
  //this.state.data.data.

  console.log(i)
  console.log(e)
  e.data.v2.value=i;
  let temp=this.state.data
  temp.data=e
  this.setState({data:temp})
  //console.log(this.state.data.data.data.v2)
  this.setState({conditionEdit:false})

}



toggleConditionValue(e){
  console.log(e)
  console.log(e.target.dataset)
  var day=e.target.dataset.day
  console.log(day)

  let temp=this.state.data
  console.log(temp.data.data)
  if(temp.data.data.days.includes(day)){
    console.log("remove "+ day)
    temp.data.data.days.splice(temp.data.data.days.indexOf(day),1)
  }else{
    console.log("add "+ day)
    temp.data.data.days.push(day)
  }

  this.setState({data:temp})

}

  alterConditionValue(e,i){
    console.log("Alter Condition value")
    console.log(e.target.dataset.var)
    console.log(e.target.dataset.var.split("."))
    console.log(e.target.value)
    console.log(i)

    let v=e.target.value
    if(isNaN(parseInt(e.target.value))==true){
        console.log("its a var now")
        v=e.target.value
    }else{
      v=parseInt(e.target.value)
    }




    let ref=e.target.dataset.var


    if(ref==undefined){
          ref="data.data.v2.value"
    }
    let temp=this.state.data

    obIndex(temp,ref,v)
    console.log(temp)
    this.setState({data:temp})



  }


  tryGetVar(varname){

    if(varname.includes("input")){
      console.log("Resolve input:"+varname)
      //Try to resolve input
      //console.log(this.props)
      for(var i=0;i<this.props.inputs.length;i++){
        //console.log(this.props.inputs[i].id)
        if(("input"+this.props.inputs[i].id+"filtered")==varname){
          if(this.props.inputs[i].type==512){
          return [true,{name:this.props.inputs[i].name}]
          }

          return [true,{name:this.props.inputs[i].name,value:[this.props.inputs[i].name_inactive,this.props.inputs[i].name_active]}]
        }
      }
    }

    if(varname.includes("state") && varname[0]=="O"){
      //Its an output
      for(var i=0;i<this.props.outputs.length;i++){
        //console.log(this.props.inputs[i].id)
        if(("O"+this.props.outputs[i].id+"state")==varname){
          return [true,{name:this.props.outputs[i].name,value:["Off","On"]}]
        }
      }

    }






    return [false,{}]
  }


  oppNames(opperator){
    //Convert the opperator to a human readable name
    switch(opperator){
        case "==":
          return "is"
        case "<":
          return "less than"
        case ">":
          return "more than"
        case ">=":
          return "more than or equal to"
        case "<=":
          return "less than or equal to"
        case "!=":
          return "not equal to"
        case "weekday":
          return "weekdays "
        case "before_time":
          return "time is before"
        case "after_time":
          return "time is after"
        case "between_time":
            return "time is between"
        default:
          return "Unknown opperator"
      }
  }

  alterOpp(i,options,current){
    console.log(i)
    console.log("options")
    console.log(options)
    console.log("current")
    console.log(current)
    let currentIndex=options.indexOf(current)
    currentIndex++
    if(currentIndex>=options.length){
      currentIndex=0
    }
    console.log(currentIndex)
    console.log("Change operation to "+options[currentIndex])

    let temp=this.state.data
    temp.data.opperator=options[currentIndex]
    console.log(temp)
    this.setState({data:temp})

  }



 conditionDisplay(data){

  let left=""
  let right=""
  let input=false
  let inputData={}


  if(data.opperator=="between_time"){
      //needs the leading 0s and what not for minutes
      var start_t=pad(data.data.start.hours,2)+":"+pad(data.data.start.mins,2)
      var end_t=pad(data.data.end.hours,2)+":"+pad(data.data.end.mins,2)
      right= start_t+" > "+end_t

  }

  if(data.opperator=="weekday"){
      //the order of the days can be random so show them in a logical order
      let daysInc=[]
      let days=data.data.days
      let monfri=false
      if(days.includes("mon")){
        daysInc.push("Monday")
      }
      if(days.includes("tue")){
        daysInc.push("Tuesday")
      }
      if(days.includes("wed")){
        daysInc.push("Wednesday")
      }
      if(days.includes("thur")){
        daysInc.push("Thursday")
      }
      if(days.includes("fri")){
        daysInc.push("Friday")
      }
      if(daysInc.length==5){
          monfri=true
      }
      if(days.includes("sat")){
        daysInc.push("Saturday")
      }
      if(days.includes("sun")){
        daysInc.push("Sunday")
      }
      if(monfri==true && daysInc.length==5)
        right=(<Label bsStyle="info">Monday-Friday</Label>)

      if(right==""){
        var parts=""
        right=(<span>{daysInc.map((e,i)=><span><Label bsStyle="info">{e}</Label>&nbsp;</span>)}</span>)
      }

  }




  if("v1" in data.data){
    if("var" in data.data.v1){
        [input,inputData]=this.tryGetVar(data.data.v1.var)
        console.log(input)
        console.log(inputData)
        if(input==true){
          left=(<Label bsStyle="info">{inputData.name}</Label>)
        }else{
          left=(<Label bsStyle="info">{data.data.v1.var}</Label>)
        }
    }
    else if("value" in data.data.v1){
      left=(<Label bsStyle="primary">{data.data.v1.value}</Label>)
    }
    else{
      left=(<Label>?</Label>)
    }
  }
  if("v2" in data.data){
    if("var" in data.data.v2){
      right=(<Label bsStyle="info">{data.data.v2.var}</Label>)
    }
    else if("value" in data.data.v2){
      if(input==true){ //What if its a temperature device, 0 and 1 ....
        try{
          if (data.data.v2.value<inputData.value.length){
            right=(<Label bsStyle="info">${inputData.value[data.data.v2.value]}</Label>)

          }
          else{
            right=(<Label bsStyle="primary">{data.data.v2.value}</Label>)
          }


        }
        catch(err){
      right=(<Label bsStyle="primary">#{data.data.v2.value}</Label>)
        }
      }else{
      right=(<Label bsStyle="primary">*{data.data.v2.value}</Label>)
      }
    }
    else{
      right=(<Label>?</Label>)
    }
  }

  //now do the editmode check?
  if(this.state.conditionEdit==true){
    if(input==true){
      //console.log(input change) <span className="fa fa-close hoverRed" onClick={()=>this.cancelEdit()}></span>
      if(data.opperator=="=="){
        return (<div>
                    {left}<b> is </b>
                    <Button className={"btn1 "+highlight(0,data.data.v2.value)} onClick={()=>this.alterCondition(data,0)} >{inputData.value[0]}</Button>
                    <Button className={"btn1 "+highlight(1,data.data.v2.value)} onClick={()=>this.alterCondition(data,1)} >{inputData.value[1]}</Button>

                </div>)
      }
      else{


        if("var" in data.data.v2){
          return (<div>
                    {left}  &nbsp;
                    <Button className="btn1 " onClick={()=>this.alterOpp(data,[">=","<=","<",">"],data.opperator)}>{this.oppNames(data.opperator)}</Button>
                    &nbsp;<input type="text" className="varInput" value={data.data.v2.var} data-var="data.data.v2.var"  onChange={(e)=>this.alterConditionValue(e,data)}></input>
                 </div>)
        }
        return (<div>
                  {left}  &nbsp;
                  <Button className="btn1 " onClick={()=>this.alterOpp(data,[">=","<=","<",">"],data.opperator)}>{this.oppNames(data.opperator)}</Button>
                  &nbsp;<input type="number" className="timeInput" value={data.data.v2.value} data-var="data.data.v2.value"  onChange={(e)=>this.alterConditionValue(e,data)}></input>
               </div>)
        }
    }else{
      if(data.opperator.length<=3){
      return(<div>
                {left}  &nbsp;
                <Button className="btn1 " onClick={()=>this.alterOpp(data,[">",">=","<=","<","==","!="],data.opperator)}>{this.oppNames(data.opperator)}</Button>
                &nbsp;<input type="number" className="timeInput" value={data.data.v2.value} data-var="data.data.v2.value"  onChange={(e)=>this.alterConditionValue(e,data)}></input>

             </div>)
           }
    }




    if(data.opperator=="between_time"){
      //console.log("Between time")
      return (<div>
                <b  >Start Time:&nbsp;</b>
                    <input className="timeInput" type="number" min="0" max="23" value={data.data.start.hours} data-var="data.data.start.hours"  onChange={(e)=>this.alterConditionValue(e,data)}></input><span><b>:</b></span>
                    <input className="timeInput" type="number" min="0" max="59" value={data.data.start.mins}  data-var="data.data.start.mins" onChange={(e)=>this.alterConditionValue(e,data)}></input>
                    <br/>
                <b   >End Time:&nbsp;&nbsp;</b>
                <input className="timeInput" type="number" min="0" max="23" value={data.data.end.hours} data-var="data.data.end.hours" onChange={(e)=>this.alterConditionValue(e,data)}></input><span><b>:</b></span>
                <input className="timeInput" type="number" min="0" max="59" value={data.data.end.mins} data-var="data.data.end.mins" onChange={(e)=>this.alterConditionValue(e,data)}></input>


                </div>)



    }

    if(data.opperator=="weekday"){
      //console.log("Between time")
      return (<div>
                <Button className={"btn1 noactive "+ArrayInculdes("mon",data.data.days)}  data-day="mon"  onClick={(e)=>this.toggleConditionValue(e)} >Mon</Button>
                <Button className={"btn1 noactive "+ArrayInculdes("tue",data.data.days)}  data-day="tue"  onClick={(e)=>this.toggleConditionValue(e)} >Tue</Button>
                <Button className={"btn1 noactive "+ArrayInculdes("wed",data.data.days)}  data-day="wed"  onClick={(e)=>this.toggleConditionValue(e)} >Wed</Button>
                <Button className={"btn1 noactive "+ArrayInculdes("thur",data.data.days)}  data-day="thur" onClick={(e)=>this.toggleConditionValue(e)}>Thur</Button>
                <Button className={"btn1 noactive "+ArrayInculdes("fri",data.data.days)}  data-day="fri"  onClick={(e)=>this.toggleConditionValue(e)} >Fri</Button>
                <Button className={"btn1 noactive "+ArrayInculdes("sat",data.data.days)}  data-day="sat"  onClick={(e)=>this.toggleConditionValue(e)} >Sat</Button>
                <Button className={"btn1 noactive "+ArrayInculdes("sun",data.data.days)}  data-day="sun"  onClick={(e)=>this.toggleConditionValue(e)} >Sun</Button>
              </div>)



    }


  }


  return (<h4>{left} <b>{this.oppNames(data.opperator)}</b> {right}</h4>)



}



  cancelEdit(){
    this.setState({conditionEdit:false})
  }

  editmode(){
    this.setState({conditionEdit:!this.state.conditionEdit})
  }


    render(){
      let conditionText=("Error")
      if(this.props.edit==true){
          return (<div>
              {this.state.tree.map((o,i) =><b key={i} onClick={()=>this.expandTree(i)} >{o} <span className="fa fa-angle-right hoverRed" ></span></b>)}
              <div className="flexit">
              {Object.keys(this.state.currentTree).map((item,i)  =><Button className="btn1 butpadding" key={i} onClick={()=>this.expandTree(item)}>{item}</Button> )}
                {/*ConditionOptions.map((e,i)=><div key={i} class="actionItem" onClick={()=>this.newConditionType(e.name)}><div class="actionOption"><Glyphicon glyph={e.icon} /></div><span>{e.name}</span></div>)*/}
              </div>
              <br/>
              <hr/>
              <Button onClick={()=>this.cancelCon()}>Cancel</Button>
              </div>)
      }
      //edit button required?
      if(this.state.data.data=="and"){
        conditionText=(<span>AND</span>)
      }
      else if(this.state.data.data=="or"){
        conditionText=(<span>OR</span>)
      }
      else{
        conditionText=this.conditionDisplay(this.state.data.data)
      }
      return (<div key={"CON"+this.props.uid}><div className={"flexFill conditionBlock tab"+this.state.data.level}><div className="simple-drag-row">{conditionText}</div><div>

      {this.props.drag==true ? (
        <span>
      {this.state.conditionEdit ?(
      <span><Button onClick={()=>this.deleteCon()}>Remove </Button><Button onClick={()=>this.editmode()}>Done</Button></span>):
      (<Button onClick={()=>this.editmode()}>Edit</Button>)}
      </span>
    ):("")}

      </div></div></div>)





    }

}



// WEBPACK FOOTER //
// ./src/programmerComponents/ConditionCreate.js